import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { rootSiteSelector, siteFromRootSiteSelector } from 'selectors/root-site';

export const DEFAULT_GUIDE_LABEL = 'Guide';
export const DEFAULT_GUIDE_LABEL_PLURAL = 'Guides';

// `siteSlug` is kept in the signature for backward compatibility with existing
// callers, but it is intentionally not used to override — the slug is always read
// from the current route via `useParams`.
// eslint-disable-next-line no-unused-vars
export const useGuideLabel = (siteSlug) => {
  const { siteSlug: routeSiteSlug } = useParams();
  const site = useSelector(routeSiteSlug ? siteFromRootSiteSelector(routeSiteSlug) : rootSiteSelector);

  return {
    label: site?.guideLabel || DEFAULT_GUIDE_LABEL,
    labelPlural: site?.guideLabelPlural || DEFAULT_GUIDE_LABEL_PLURAL,
  };
};
